import React, {useRef} from 'react';
import {
    CBadge,
    CButton,
    CCard,
    CCardBody, CCardFooter,
    CCardTitle,
    CCol,
    CContainer,
    CFormInput,
    CFormLabel,
    CFormText,
    CRow
} from "@coreui/react";
import {default as RTable} from '../../components/Table';
import Helper from "../../application/helper";
import {useDispatch, useSelector} from "react-redux";
import CustomerSearch from "../../components/SearchInputs/CustomerSearch";
import CreatedUserSearch from "../../components/SearchInputs/CreatedUserSearch";
import CreatedAtSearch from "../../components/SearchInputs/CreatedAtSearch";
import CustomerLedgerMemoSearch from "../../components/SearchInputs/CustomerLedgerMemoSearch";
import MemoApprovedSearch from "../../components/SearchInputs/MemoApprovedSearch";
import MemoRejectedSearch from "../../components/SearchInputs/MemoRejectedSearch";
import NoteSearch from "../../components/SearchInputs/NoteSearch";
import {applyFilter} from "../../store/slice/component/table";
import Search from "../../components/SearchInputs/Search";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '../../../sass/responsive_table.scss';
import TBodyDesktop from "./TBodyDesktop";
import TBodyMobile from "./TBodyMobile";
import {useMediaQuery} from "react-responsive";

const List = () => {
    const tableRef = useRef();
    const dispatch = useDispatch([]);
    const list = useSelector(state => state.entities.component_table);
    const add = () => {
        window.location.href = Helper.route(tableRef.current.getState() + '.add');
    }
    const Desktop = ({children}) => {
        const isDesktop = useMediaQuery({minWidth: 992})
        return isDesktop ? children : null
    }
    const Mobile = ({children}) => {
        const isMobile = useMediaQuery({maxWidth: 992});
        return isMobile ? children : null;
    }

    return <>
        <RTable ref={tableRef}>
            <>
                <Table className={'table'} align="middle">
                    <Desktop>
                        <Thead>
                            <Tr>
                                <Th scope="col">Memo Number</Th>
                                <Th scope="col">By</Th>
                                <Th scope="col">Customer</Th>
                                <Th scope="col">Amount</Th>
                                <Th scope="col">Transaction Type</Th>
                                <Th scope="col"/>
                                <Th scope="col">
                                    <CButton size={'sm'} color="primary" onClick={() => add()}
                                             className={'float-start'}
                                    >Make Memo</CButton>
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            <TBodyDesktop add={add} list={list}/>
                        </Tbody>
                    </Desktop>
                    <Mobile>
                        <Thead>
                            <Tr>
                                <Th scope="col">#</Th>
                                <Th scope="col">By</Th>
                                <Th scope="col">CUS</Th>
                                <Th scope="col">A</Th>
                                <Th scope="col">TYP</Th>
                                <Th scope="col"/>
                                <Th scope="col"><CBadge size={'sm'} color="primary" onClick={() => add()}
                                                        className={'float-start m-1'}
                                >N</CBadge></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            <TBodyMobile add={add} list={list}/>
                        </Tbody>
                    </Mobile>
                </Table>
            </>
        </RTable>
        <CContainer fluid={true} className={'pt-3'}>
            <CCard>
                <CCardBody>
                    <CCardTitle>
                        Search/Filter Listing
                    </CCardTitle>
                    <CRow className={'mb-1'}>
                        <CCol sm={12} md={4}>
                            <CustomerLedgerMemoSearch/>
                        </CCol>
                        <CCol sm={12} md={4}>
                            <CreatedUserSearch/>
                        </CCol>
                        <CCol sm={12} md={4}>
                            <CreatedAtSearch/>
                        </CCol>
                    </CRow>
                    <CRow className={'mt-3'}>
                        <CCol>
                            <CustomerSearch/>
                        </CCol>
                    </CRow>
                    <CRow className={'mt-3'}>
                        <CCol sm={12} md={6}>
                            <MemoApprovedSearch/>
                        </CCol>
                        <CCol sm={12} md={6}>
                            <MemoRejectedSearch/>
                        </CCol>
                    </CRow>
                    <CRow className={'mt-3'}>
                        <CCol sm={12} md={4}>
                            <NoteSearch/>
                        </CCol>
                        <CCol sm={12} md={4}>
                            <CFormLabel>Amount</CFormLabel>
                            <CFormInput type="text"
                                        onChange={(e) => {
                                            dispatch(applyFilter({
                                                field_name: 'amount',
                                                value: e.target.value,
                                            }));
                                        }}
                                        defaultValue={list.amount || ''}
                            />
                            <CFormText>Example: 50, 422, 300</CFormText>
                        </CCol>
                        <CCol sm={12} md={4}>
                            <CFormLabel>Transaction Type</CFormLabel>
                            <CFormInput type="text"
                                        onChange={(e) => {
                                            dispatch(applyFilter({
                                                field_name: 'transaction_type',
                                                value: e.target.value,
                                            }));
                                        }}
                                        defaultValue={list.transaction_type || ''}
                            />
                            <CFormText>Just Type: d for deposit, w = withdrawal, or full</CFormText>
                            <CFormText>d,w :: deposit,withdrawal :: deposit :: withdrawal</CFormText>
                            <CFormText>Example: d</CFormText>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <Search onSearch={() => {
                        tableRef.current.callFromSubmitted(list)
                    }}/>
                </CCardFooter>
            </CCard>
        </CContainer>
    </>;

}

export default List;
